module.exports = "pegasus/assets/themelp1/charity/102.png";